import React, { Component, } from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
  // Grade
} from '../../components'
import Styles from './TspDisclaimer.css'

@CSSModules(Styles)
export default class TspDisclaimer extends Component {
  constructor(props){
    super(props)
  }
  //
  getIndex(fund_id){
    return {
      'FTSP00000C':['S&P 500 Index', 'iShares Core S&P 500 ETF', 'IVV', 'FSUSA00B4O', 'FEUSA0000E'],
      'FTSP00000I':['MSCI EAFE Index', 'iShares MSCI EAFE ETF', 'EFA', 'FSUSA00B7C', 'FEUSA0002W'],
      'FTSP00000S':['Dow Jones U.S. Completion Total Stock Market Index', 'Fidelity® Extended Market Index Fund', 'FSMAX', 'FSUSA003EG', 'F00000MJRH'],
    }[fund_id] || []
  }
  //
  getShareclassUrl(indexConfig){
    const safeTicker = indexConfig[2] || 'N'

    const A = `${config.domain}`
    const B = `${config.routes.fund}/`
    const C = `${format.sanitize(indexConfig[1])}/`
    const D = `${safeTicker}/`
    const E = `${config.profilePath}/`
    const F = `${indexConfig[3]}/`
    const G = `${indexConfig[4]}/`

    return `${A}${B}${C}${D}${E}${F}${G}`
  }
  //
  render() {
    if (!this.props.shareclass) { return null }
    //
    const index = this.getIndex(this.props.shareclass.fund_id)
    let indexName = null
    let indexFundName = null
    let indexFundTicker = null
    let indexUrl = null

    if (index && index.length > 0) {
      indexName = index[0]
      indexFundName = index[1]
      indexFundTicker = index[2]
      indexUrl = this.getShareclassUrl(index)
    }
    //
    return (
      <div styleName='tsp-disclaimer'>
        <div styleName='tsp-disclaimer-icon'>
          <LinkIcon nospace faclass='fa-info-circle' />
        </div>
        <p>
          The Thrift Savings Plan funds do not publish full
          portfolio holdings, but they track indexes that
          are shared with other mutual funds.
          { indexName ?
              <span>
                &nbsp;{this.props.shareclass.fund_legal_name} tracks the {indexName}.
                The results below are based on the holdings of the <Link
                  to={indexUrl}
                  title={indexFundName}
                  xstrong
                ><span styleName='tsp-index-link'>{indexFundName}</span></Link> ({indexFundTicker}),
                which tracks the same index.
              </span> :
              <span>
                &nbsp;{this.props.shareclass.fund_legal_name} is a mix of the TSP
                C, S, I, F, and G funds. We model the L fund portfolios
                using the allocation details published by the Thrift
                Savings Plan, and use matching index funds to represent
                the constituent TSP funds.
              </span>
          }
        </p>
      </div>
    )
  }
}
